import React from "react";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Col } from "reactstrap";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ClientTabs from "./ClientTabs";

export default function ClientOverview(props) {
  const [editView, showEditView] = React.useState(false);

  return (
    <Card
      className="dark-card"
      style={{ margin: 0, height: "100%", padding: 0 }}
    >
      {props.subLabel ? (
        <div className="inline-flex" style={{ width: "100%", padding: "0px" }}>
          <Col className="text-left">
            <Typography variant="p">
              <SystemLabel name={props.subLabel} />
            </Typography>
          </Col>
        </div>
      ) : null}
      <CardContent style={{ height:'100%', padding: 0 }}>
        <ClientTabs {...props} />
      </CardContent>
    </Card>
  );
}
